import { render, staticRenderFns } from "./TierNavItem.vue?vue&type=template&id=41d9c1f0&"
import script from "./TierNavItem.vue?vue&type=script&lang=js&"
export * from "./TierNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports